/* eslint-disable formatjs/no-literal-string-in-jsx */
import { useEffect } from "react";

import { isChunkError, reloadOnce } from "@/shared/misc/chunkReload";

import { CfLoader } from "../../../shared/components/common/CfLoader/CfLoader";

type Props = {
  error: unknown;
};

const ChunkErrorFallback = ({ error }: Props) => {
  // we don't want refresh to happen on localhost
  const isLocalhost = window.location.hostname === "localhost";
  const shouldReload = isChunkError(error) && !isLocalhost;

  useEffect(() => {
    if (shouldReload) {
      reloadOnce();
    }
  }, [shouldReload]);

  if (shouldReload) {
    // oxlint-disable-next-line no-console
    console.warn(
      "[ChunkErrorFallback] Chunk load failed. Forcing hard reload.",
    );
    return <div>Updating app... Please wait.</div>;
  }

  // Anything that is not a chunk load lands on a loader that never resolves, so
  // without this the only symptom of a fatal render error is a spinner.
  // oxlint-disable-next-line no-console
  console.error(
    "[ChunkErrorFallback] Unhandled error, app tree unmounted:",
    error,
  );

  return (
    <div>
      <CfLoader />
    </div>
  );
};

export { ChunkErrorFallback };
